import { DocumentType } from "domain/entities/document-type";
import { BaseInputFilter } from "domain/models/base-input-filter";
import {
  useCreateDocumentTypeMutation,
  useUpdateDocumentTypeMutation,
} from "presentation/hooks/use-query-document-type";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";

interface DocumentTypeFormProps {
  visible: boolean;
  onHide: () => void;
  documentType?: DocumentType;
}

const DocumentTypeForm: React.FC<DocumentTypeFormProps> = ({
  visible,
  onHide,
  documentType,
}) => {
  const toast = useRef<Toast>(null);
  const [formData, setFormData] = useState<DocumentType>();
  const [contractTypeOptions, setContractTypeOptions] = useState<string[]>([]);

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
    type: "contractType",
  } as BaseInputFilter);

  const { mutate: createDocumentType, isPending: isCreating } =
    useCreateDocumentTypeMutation();
  const { mutate: updateDocumentType, isPending: isUpdating } =
    useUpdateDocumentTypeMutation();

  useEffect(() => {
    if (parameters?.data) {
      setContractTypeOptions(parameters.data.map((p) => p.value));
    }
  }, [parameters]);

  useEffect(() => {
    setFormData(documentType);
  }, [documentType]);

  const handleSave = () => {
    if (!formData) return;

    const mutationOptions = {
      onSuccess: () => {
        toast.current?.show({
          severity: "success",
          summary: "Sucesso",
          detail: `Tipo de Documento ${
            formData.id ? "atualizado" : "criado"
          } com sucesso.`,
          life: 3000,
        });
        onHide();
      },
      onError: (error: any) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail:
            error.response?.data?.message ||
            "Ocorreu um erro ao guardar o tipo de documento.",
          life: 3000,
        });
      },
    };

    if (formData.id) {
      updateDocumentType(formData, mutationOptions);
    } else {
      createDocumentType(formData, mutationOptions);
    }
  };

  const footer = (
    <div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        onClick={onHide}
        className="p-button-text"
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        onClick={handleSave}
        loading={isCreating || isUpdating}
      />
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        header="Tipo de Documento"
        visible={visible}
        onHide={onHide}
        footer={footer}
        style={{ width: "35vw" }}
        modal
      >
        <div className="p-fluid formgrid grid">
          <div className="field col-12">
            <label htmlFor="name">Nome</label>
            <InputText
              id="name"
              value={formData?.name || ""}
              onChange={(e) =>
                setFormData(
                  (prev) => ({ ...prev, name: e.target.value } as DocumentType)
                )
              }
            />
          </div>
          <div className="field col-12">
            <label htmlFor="contractTypes">Tipos de Contrato</label>
            <MultiSelect
              id="contractTypes"
              value={formData?.contractTypes || []}
              options={contractTypeOptions}
              onChange={(e) =>
                setFormData(
                  (prev) =>
                    ({ ...prev, contractTypes: e.value } as DocumentType)
                )
              }
              placeholder="Selecione os tipos"
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default DocumentTypeForm;
